import { createRoot } from 'react-dom/client'

import GlobalError from '../error/GlobalError'

export const renderGlobalError = (error: unknown) => {
    const rootElement = document.getElementById('root')
    if (rootElement) {
        createRoot(rootElement).render(<GlobalError />)
    }
    throw error
}
